import { combineReducers } from "@reduxjs/toolkit";
import type { ActivitiesAvailabilityState } from "../features/availability/store";
import activitiesAvailabilityReducer from "../features/availability/store/slice";
import { activitiesPostBookingApi } from "../features/postBooking/store";
import type { ActivitiesShopState } from "../features/shop/store";
import activitiesShopReducer from "../features/shop/store/slice";
import { createActivityUrlMiddleware } from "./urlMiddleWare";

export interface ActivitiesState {
  activities: {
    activitiesAvailability: ActivitiesAvailabilityState;
    activitiesShop: ActivitiesShopState;
  };
}

export const activitiesRootReducer = combineReducers({
  activitiesAvailability: activitiesAvailabilityReducer,
  activitiesShop: activitiesShopReducer,
});

export const activityReducers = {
  activities: activitiesRootReducer,
  [activitiesPostBookingApi.reducerPath]: activitiesPostBookingApi.reducer,
};

export const activityMiddlewares = [
  activitiesPostBookingApi.middleware,
  createActivityUrlMiddleware(),
];

export { activitiesPostBookingApi };
